import { App as Table } from 'map-table'
import { memo } from 'react'
import { useDispatch } from 'react-redux'
import { useFilterResults } from '~map-filter-view/states/filter'
import { useJsonFeatures, useProperties } from '~map-preview/states/map'
import { closeTable, useIsMapTableOpen } from '~map-preview/states/ui'

const Component = (props) => {
  const filterResults = useFilterResults()
  const properties = useProperties()
  const jsonFeatures = useJsonFeatures()

  return (
    <Table
      {...props}
      shouldUseCollapse={false}
      filters={[]}
      filterResults={filterResults}
      properties={properties}
      jsonFeatures={jsonFeatures}
    />
  )
}

const MapTable = memo(function MapTable(props) {
  const dispatch = useDispatch()
  const isMapTableOpen = useIsMapTableOpen()

  if (!isMapTableOpen) return null

  const handleClose = () => {
    dispatch(closeTable())
  }

  return (
    <Component
      {...props}
      onClose={handleClose}
    />
  )
})

export { MapTable }
